import { format } from 'date-fns';
import { parseMultiSelect } from '../../../utils/filtersApi';

export const SEC_FILTER_DEFAULTS = {
  company: 'All companies',
  type: 'All form types',
  xbrlTag: 'All XBRL tags',
};

export const parseIsoDateLocal = (iso) => {
  if (!iso) return null;
  const parts = String(iso).split('-');
  if (parts.length !== 3) return null;
  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

export const matchesSecFilingSearch = (row, term) => {
  if (!term) return true;
  const q = term.toLowerCase();
  return [
    row.accessionNumber,
    row.company,
    row.companyShort,
    row.entity,
    row.filingType,
    row.cik,
    row.xbrlTag,
    row.xbrlTagDisplay,
  ].some((field) => String(field || '').toLowerCase().includes(q));
};

export function getSecFilingFilterCatalogs({
  formTypes = [],
  xbrlTags = [],
  companies = [],
} = {}) {
  return {
    formTypes,
    xbrlTagCatalog: xbrlTags,
    companyCatalog: companies,
  };
}

export function getSecFilingFilterSelections({
  filterCompany,
  filterFormType,
  filterXbrlTag,
  formTypes,
  xbrlTagCatalog,
  companyCatalog,
}) {
  return {
    selectedCompanies: parseMultiSelect(
      filterCompany,
      SEC_FILTER_DEFAULTS.company,
      companyCatalog,
    ),
    selectedFormTypes: parseMultiSelect(
      filterFormType,
      SEC_FILTER_DEFAULTS.type,
      formTypes,
    ),
    selectedXbrlTags: parseMultiSelect(
      filterXbrlTag,
      SEC_FILTER_DEFAULTS.xbrlTag,
      xbrlTagCatalog,
    ),
  };
}

export function applySecFilingRowFilters(rows, {
  selectedCompanies = [],
  selectedFormTypes = [],
  selectedXbrlTags = [],
  filedFromIso = '',
  filedToIso = '',
  searchTerm = '',
} = {}) {
  return rows.filter((row) => {
    if (selectedCompanies.length && !selectedCompanies.includes(row.company)) return false;
    if (selectedFormTypes.length && !selectedFormTypes.includes(row.filingType)) return false;
    if (selectedXbrlTags.length && !selectedXbrlTags.includes(row.xbrlTag)) return false;
    if (filedFromIso && (!row.filedDate || row.filedDate < filedFromIso)) return false;
    if (filedToIso && (!row.filedDate || row.filedDate > filedToIso)) return false;
    if (!matchesSecFilingSearch(row, searchTerm)) return false;
    return true;
  });
}

export function hasSecFilingFiltersApplied({
  selectedCompanies = [],
  selectedFormTypes = [],
  selectedXbrlTags = [],
  filedStart = null,
  filedEnd = null,
} = {}) {
  return selectedCompanies.length > 0
    || selectedFormTypes.length > 0
    || selectedXbrlTags.length > 0
    || Boolean(filedStart)
    || Boolean(filedEnd);
}

export function filedDatesToIso(filedStart, filedEnd) {
  return {
    filedFromIso: filedStart ? format(filedStart, 'yyyy-MM-dd') : '',
    filedToIso: filedEnd ? format(filedEnd, 'yyyy-MM-dd') : '',
  };
}
